import { Box, Typography } from '@mui/material';
import redeemedCouponFooterSrc from '../../assets/bazzar/redeemed-coupon-footer.png';
import AccessCouponButton from './AccessCouponButton';

const CARD_WIDTH = 250;
const BANNER_HEIGHT = 171;

const headerFallbackGradient = {
  cinema: 'linear-gradient(145deg, #0b0205, #2e1500 45%, #0b0205)',
  food: 'linear-gradient(145deg, #4f1300, #d83a00 45%, #f0b135)',
  fashion: 'linear-gradient(145deg, #123d58, #ffffff 48%, #e6006e)',
};

const bannerBottomMask = {
  WebkitMaskImage:
    'radial-gradient(circle 12px at bottom left, transparent 98%, black 100%), radial-gradient(circle 12px at bottom right, transparent 98%, black 100%)',
  maskImage:
    'radial-gradient(circle 12px at bottom left, transparent 98%, black 100%), radial-gradient(circle 12px at bottom right, transparent 98%, black 100%)',
  WebkitMaskComposite: 'source-in',
  maskComposite: 'intersect',
};

const contentTopMask = {
  WebkitMaskImage:
    'radial-gradient(circle 12px at top left, transparent 98%, black 100%), radial-gradient(circle 12px at top right, transparent 98%, black 100%)',
  maskImage:
    'radial-gradient(circle 12px at top left, transparent 98%, black 100%), radial-gradient(circle 12px at top right, transparent 98%, black 100%)',
  WebkitMaskComposite: 'source-in',
  maskComposite: 'intersect',
};

const contentPanelGradient =
  'linear-gradient(180deg, #940cdb 0%, #8708e7 25%, #7804f2 50%, #6b00fe 75%, #6a00ff 100%)';

const ticketBorder = '1px solid rgba(255, 255, 255, 0.95)';

export default function RedeemedCouponCard({ coupon, onAccessCoupon }) {
  const imageUrl = coupon?.imageUrl;
  const imageTone = coupon?.imageTone || 'fashion';
  const headerGradient = headerFallbackGradient[imageTone] || headerFallbackGradient.fashion;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: CARD_WIDTH,
        borderRadius: '16px 16px 0 0',
        overflow: 'visible',
        boxShadow: '0 6px 8px rgba(0, 0, 0, 0.35)',
        bgcolor: 'transparent',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box
        sx={{
          height: BANNER_HEIGHT,
          overflow: 'hidden',
          flexShrink: 0,
          borderRadius: '15px 15px 0 0',
          border: ticketBorder,
          borderBottom: 0,
          position: 'relative',
          ...bannerBottomMask,
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            bottom: -12,
            width: 29,
            height: 25,
            borderRadius: '50%',
            background: 'transparent',
            zIndex: 3,
          },
          '&::before': {
            left: -17,
            borderRight: ticketBorder,
          },
          '&::after': {
            right: -17,
            borderLeft: ticketBorder,
          },
        }}
      >
        {imageUrl ? (
          <Box
            component="img"
            src={imageUrl}
            alt={coupon?.brand || coupon?.title || 'Coupon'}
            sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              background: headerGradient,
              display: 'grid',
              placeItems: 'center',
              color: coupon?.brand === 'PVR' ? '#ffc400' : '#fff',
              fontSize: 22,
              fontWeight: 900,
            }}
          >
            {coupon?.brand || 'Voucher'}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexShrink: 0,
          position: 'relative',
          borderLeft: ticketBorder,
          borderRight: ticketBorder,
          borderTop: ticketBorder,
          borderBottom: 0,
          ...contentTopMask,
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: -12,
            width: 29,
            height: 25,
            borderRadius: '50%',
            background: 'transparent',
            zIndex: 3,
          },
          '&::before': {
            left: -17,
            borderRight: ticketBorder,
          },
          '&::after': {
            right: -17,
            borderLeft: ticketBorder,
          },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            px: '21px',
            pt: '24px',
            pb: '31px',
            textAlign: 'center',
            color: '#fff',
            background: contentPanelGradient,
            ...contentTopMask,
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: 16,
              lineHeight: '24px',
              mb: '14px',
              letterSpacing: '0.8px',
            }}
          >
            {coupon?.title}
          </Typography>

          {coupon?.validTill ? (
            <Typography
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontWeight: 500,
                fontSize: 14,
                lineHeight: '20px',
                letterSpacing: '0.5px',
                mb: '20px',
              }}
            >
              {coupon.validTill}
            </Typography>
          ) : (
            <Box sx={{ mb: '20px' }} />
          )}

          <AccessCouponButton
            onClick={() => onAccessCoupon?.(coupon)}
            disabled={coupon?.canAccessCoupon === false}
          />

        </Box>
          <Box
            component="img"
            src={redeemedCouponFooterSrc}
            alt=""
            aria-hidden="true"
            sx={{
              
              width: '100%',
              height: 11,
              display: 'block',
              objectFit: 'cover',
              pointerEvents: 'none',
            }}
          />
      </Box>
    </Box>
  );
}
